import { Content } from 'src/app/models/content.model';

export const TOOLS_CONTENT: Content = new Content({
   idContent: 'ed50542c6ca94fc909e8391bd59c69fc',
   order: 1,
   title: 'Herramientas de apoyo',
   content: `
   <div class="row">
      <div class="col-12 row">
         <div class="w-auto mx-auto">
            <app-button-url
               [url]="'http://www.gob.mx/cms/uploads/attachment/file/55289/7._Ejemplo_de_tabulador_de_sueldos.pdf'"
               [title]="'Tabulador de sueldos'"
               [icon]="'description'">
            </app-button-url>
         </div>
      </div>
   </div>
   `,
   subContents: [
   ]
});